// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__1EObo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin: 0 6px;
  padding: 0.6rem 1.2rem;
  font-size: 1rem;
  box-sizing: border-box;
}

/* Disabled */
.Button_button__1EObo:disabled {
  pointer-events: none;
  opacity: 0.6;
  box-shadow: none;
  background-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.4);
}

/* VARIANTS */

/* Default */
.Button_default__aqJNC {
  background: linear-gradient(135deg, #5b2a85, #3b0a60);
  color: #ffffff;
  font-weight: 600;
  padding: 12px 24px;
  font-size: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 0 12px rgba(143, 100, 200, 0.35), 0 4px 18px rgba(100, 50, 170, 0.3),
    inset 0 0 6px rgba(200, 150, 255, 0.08);
}

.Button_default__aqJNC:hover {
  background: linear-gradient(135deg, #6a36a5, #4f1380);
  box-shadow: 0 0 20px rgba(160, 120, 255, 0.5), 0 6px 24px rgba(100, 60, 190, 0.35);
}

.Button_default__aqJNC:active {
  transform: scale(0.97);
  box-shadow: 0 2px 10px rgba(120, 90, 200, 0.3);
}

.Button_default__aqJNC:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(160, 130, 255, 0.3);
}

/* Destructive */
.Button_destructive__ZF14G {
  background: linear-gradient(145deg, #ff4d4f, #ff7679);
  color: white;
  box-shadow: 0 4px 10px rgba(255, 77, 79, 0.4);
}

.Button_destructive__ZF14G:hover {
  background: linear-gradient(145deg, #ff7679, #ff4d4f);
  box-shadow: 0 0 16px rgba(255, 77, 79, 0.5);
}

/* Outline */
.Button_outline__h0W25 {
  background-color: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  color: white;
}

.Button_outline__h0W25:hover {
  border-color: #8a62e6;
  background-color: rgba(255, 255, 255, 0.06);
  box-shadow: 0 0 8px rgba(138, 98, 230, 0.4);
}

/* Secondary */
.Button_secondary__UYCbK {
  background-color: #4a3b7d;
  color: white;
  box-shadow: 0 4px 8px rgba(74, 59, 125, 0.3);
}

.Button_secondary__UYCbK:hover {
  background-color: #5f4fa0;
  box-shadow: 0 0 12px rgba(74, 59, 125, 0.4);
}

/* Ghost */
.Button_ghost__IBLbO {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.7);
}

.Button_ghost__IBLbO:hover {
  background-color: rgba(255, 255, 255, 0.06);
}

/* Link */
.Button_link__BawJ2 {
  background-color: transparent;
  color: #3a82f7;
  text-decoration: underline;
  padding: 0;
  height: auto;
}

.Button_link__BawJ2:hover {
  color: #5c9eff;
}

/* SIZES */

/* Default size */
.Button_default__aqJNC {
  height: 40px;
  font-size: 1rem;
  padding: 0 1.2rem;
}

/* Small */
.Button_sm__ya7Lw {
  height: 32px;
  font-size: 0.875rem;
  padding: 0 1rem;
}

/* Large */
.Button_lg__LSqUY {
  height: 58px;
  font-size: 1.125rem;
  padding: 0.75rem 1.5rem;
}

/* Icon button (square) */
.Button_icon__eBWPD {
  height: 40px;
  width: 40px;
  padding: 0;
}

/* Анимация привлечения внимания */
.Button_pulse__omACT {
  animation: Button_pulse__omACT 1.5s infinite ease-in-out;
}

@keyframes Button_pulse__omACT {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Button/Button.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA,aAAa;;AAEb,YAAY;AACZ;EACE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB;2CACyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,kFAAkF;AACpF;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,qDAAqD;EACrD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,UAAU;AACV;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,SAAS;AACT;EACE,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;EAC1B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;;AAEV,iBAAiB;AACjB;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,wDAA0C;AAC5C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  border: none;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  margin: 0 6px;\n  padding: 0.6rem 1.2rem;\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n/* Disabled */\n.button:disabled {\n  pointer-events: none;\n  opacity: 0.6;\n  box-shadow: none;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.4);\n}\n\n/* VARIANTS */\n\n/* Default */\n.default {\n  background: linear-gradient(135deg, #5b2a85, #3b0a60);\n  color: #ffffff;\n  font-weight: 600;\n  padding: 12px 24px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  box-shadow: 0 0 12px rgba(143, 100, 200, 0.35), 0 4px 18px rgba(100, 50, 170, 0.3),\n    inset 0 0 6px rgba(200, 150, 255, 0.08);\n}\n\n.default:hover {\n  background: linear-gradient(135deg, #6a36a5, #4f1380);\n  box-shadow: 0 0 20px rgba(160, 120, 255, 0.5), 0 6px 24px rgba(100, 60, 190, 0.35);\n}\n\n.default:active {\n  transform: scale(0.97);\n  box-shadow: 0 2px 10px rgba(120, 90, 200, 0.3);\n}\n\n.default:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(160, 130, 255, 0.3);\n}\n\n/* Destructive */\n.destructive {\n  background: linear-gradient(145deg, #ff4d4f, #ff7679);\n  color: white;\n  box-shadow: 0 4px 10px rgba(255, 77, 79, 0.4);\n}\n\n.destructive:hover {\n  background: linear-gradient(145deg, #ff7679, #ff4d4f);\n  box-shadow: 0 0 16px rgba(255, 77, 79, 0.5);\n}\n\n/* Outline */\n.outline {\n  background-color: transparent;\n  border: 1.5px solid rgba(255, 255, 255, 0.3);\n  color: white;\n}\n\n.outline:hover {\n  border-color: #8a62e6;\n  background-color: rgba(255, 255, 255, 0.06);\n  box-shadow: 0 0 8px rgba(138, 98, 230, 0.4);\n}\n\n/* Secondary */\n.secondary {\n  background-color: #4a3b7d;\n  color: white;\n  box-shadow: 0 4px 8px rgba(74, 59, 125, 0.3);\n}\n\n.secondary:hover {\n  background-color: #5f4fa0;\n  box-shadow: 0 0 12px rgba(74, 59, 125, 0.4);\n}\n\n/* Ghost */\n.ghost {\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.ghost:hover {\n  background-color: rgba(255, 255, 255, 0.06);\n}\n\n/* Link */\n.link {\n  background-color: transparent;\n  color: #3a82f7;\n  text-decoration: underline;\n  padding: 0;\n  height: auto;\n}\n\n.link:hover {\n  color: #5c9eff;\n}\n\n/* SIZES */\n\n/* Default size */\n.default {\n  height: 40px;\n  font-size: 1rem;\n  padding: 0 1.2rem;\n}\n\n/* Small */\n.sm {\n  height: 32px;\n  font-size: 0.875rem;\n  padding: 0 1rem;\n}\n\n/* Large */\n.lg {\n  height: 58px;\n  font-size: 1.125rem;\n  padding: 0.75rem 1.5rem;\n}\n\n/* Icon button (square) */\n.icon {\n  height: 40px;\n  width: 40px;\n  padding: 0;\n}\n\n/* Анимация привлечения внимания */\n.pulse {\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__1EObo`,
	"default": `Button_default__aqJNC`,
	"destructive": `Button_destructive__ZF14G`,
	"outline": `Button_outline__h0W25`,
	"secondary": `Button_secondary__UYCbK`,
	"ghost": `Button_ghost__IBLbO`,
	"link": `Button_link__BawJ2`,
	"sm": `Button_sm__ya7Lw`,
	"lg": `Button_lg__LSqUY`,
	"icon": `Button_icon__eBWPD`,
	"pulse": `Button_pulse__omACT`
};
export default ___CSS_LOADER_EXPORT___;
